import React from "react";
import SocialCallback from "./social-callback";

export const GoogleCallback: React.FC = () => {
  return <SocialCallback provider="google" />;
};

export default GoogleCallback;
